import ArticleLoading from 'modules/website/components/Article/ArticleLoading/ArticleLoading';
import { useInformationPage } from 'modules/website/hooks/useInformationPage';
import React from 'react'
import { Container } from 'react-bootstrap';
import NotFoundView from '../NotFoundView/NotFoundView';
import Article from 'modules/website/components/Article/Article';
import { useLocation, useParams } from 'react-router-dom';
import styles from './SimpleAboutUsInfoView.module.scss'

export default function SimpleAboutUsInfoView() {
    const location = useLocation();
    //const alias = location.pathname.replace('/about_us/press_room/', '');
    const {alias} = useParams();
    const { isLoading, isError, payload, error } = useInformationPage({
        alias: alias,
    });
    return (
        <>

            {isLoading &&
                <>
                    <div className={`${styles.title}`}>ABOUT US</div>
                    <Container>
                        <ArticleLoading />
                    </Container>
                </>
            }
            {!isLoading && isError && <NotFoundView />}
            {!isLoading && !isError && payload && (
                <>
                    <div className={`${styles.title}`}>ABOUT US</div>
                    <Container>
                        <Article title={payload.title} mediaSharing>
                            <div dangerouslySetInnerHTML={{ __html: payload.body }} />
                        </Article>
                    </Container>
                </>
            )}

        </>
    )
}
